export const ProductDefaultValue: IProduct["get"] = {
    id: 0,
    faName: "",
    enName: "",
    seoName: "",
    price: 0,
    url: "",
    image: "",
    brands: [],
    categories: [],
    tags: [],
    platform: null,
    views: 0,
    isPublish: true,
    code: "",
    lcdSize: "",
    description: "",
    seoCanonical: "",
    seoDescription: "",
    seoKeywords: "",
    updateDateTime: "",
    createDateTime: "",
};
